var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOulinesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 420,
    viewBox: "0 0 1080 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12252_30934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1080,
    height: 420
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 420,
    rx: 6,
    fill: "#141D2B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12252_30934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.141 259.679C241.233 125.671 320.76 -12.0729 454.768 -47.9802C588.776 -83.8876 726.52 -4.36099 762.427 129.647C798.335 263.655 718.808 401.399 584.8 437.306C450.792 473.214 313.048 393.687 277.141 259.679Z",
    stroke: "#202837",
    strokeWidth: 2.00567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.277 -2.21834C660.113 -8.77521 664.485 -15.034 671.042 -16.1979C677.599 -17.3617 683.858 -12.9898 685.022 -6.43291C686.185 0.123953 681.814 6.38279 675.257 7.54662C668.7 8.71044 662.441 4.33852 661.277 -2.21834Z",
    fill: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.732 109.534C267.573 101.583 273.078 94.198 281.029 93.0389C288.98 91.8797 296.365 97.3851 297.524 105.336C298.683 113.287 293.178 120.671 285.227 121.831C277.276 122.99 269.891 117.484 268.732 109.534Z",
    fill: "#0B121F",
    stroke: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.226 320.729C740.092 322.769 738.999 324.966 738.14 327.076C737.52 328.598 737.018 330.085 736.712 331.442C736.41 332.776 736.29 334.017 736.456 335.055C736.482 336.105 736.828 337.304 737.369 338.56C737.919 339.837 738.684 341.207 739.572 342.59C740.803 344.507 742.279 346.467 743.768 348.264C741.728 347.13 739.531 346.038 737.421 345.179C735.899 344.559 734.412 344.057 733.055 343.75C731.721 343.449 730.48 343.328 729.442 343.495C728.392 343.521 727.194 343.867 725.938 344.407C724.66 344.957 723.29 345.723 721.907 346.611C719.99 347.842 718.03 349.318 716.233 350.806C717.367 348.767 718.459 346.57 719.318 344.46C719.938 342.937 720.44 341.45 720.747 340.094C721.048 338.76 721.169 337.518 721.002 336.481C720.976 335.431 720.63 334.232 720.09 332.976C719.54 331.698 718.774 330.329 717.886 328.945C716.655 327.028 715.179 325.069 713.691 323.271C715.73 324.405 717.927 325.498 720.037 326.357C721.56 326.977 723.047 327.479 724.403 327.785C725.737 328.087 726.979 328.207 728.016 328.041C729.066 328.014 730.265 327.669 731.521 327.128C732.798 326.578 734.168 325.813 735.552 324.925C737.469 323.694 739.428 322.217 741.226 320.729Z",
    fill: "#0B121F",
    stroke: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.033 279C158.454 105.167 261.614 -73.5114 435.447 -120.09C609.28 -166.668 787.959 -63.5082 834.537 110.325C881.116 284.158 777.956 462.836 604.123 509.415C430.29 555.993 251.611 452.833 205.033 279Z",
    stroke: "#202837",
    strokeWidth: 2.00251,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.571 335.192L239.646 317.111L257.728 350.186L224.652 368.267L206.571 335.192Z",
    fill: "#8CCB0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.645 317.111L257.726 350.186L224.65 368.268L239.645 317.111Z",
    fill: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.394 190.403L866.418 192.02L843.506 228.471L823.394 190.403Z",
    fill: "#0B121F",
    stroke: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.519 301.914C60.2858 80.8523 191.473 -146.371 412.535 -205.604C633.597 -264.838 860.82 -133.65 920.053 87.4116C979.287 308.473 848.099 535.697 627.038 594.93C405.976 654.163 178.753 522.976 119.519 301.914Z",
    stroke: "#202837",
    strokeWidth: 2.02758,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.011 -219.606C675.131 -225.216 837.381 -126.113 904.213 39.9692C906.035 44.4964 907.771 49.0372 909.423 53.5893",
    stroke: "#9FEF00",
    strokeWidth: 2.02758,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.489 89.9065C714.667 75.2298 725.088 61.8556 739.765 60.0339C754.441 58.2122 767.815 68.633 769.637 83.3097C771.459 97.9864 761.038 111.361 746.361 113.182C731.685 115.004 718.31 104.583 716.489 89.9065Z",
    fill: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.817 38.5069C871.664 36.4417 874.522 34.1727 877.04 31.8725C879.023 30.061 880.811 28.2161 882.221 26.4236C883.602 24.6669 884.663 22.9058 885.156 21.2338C885.862 19.6403 886.193 17.6109 886.277 15.3779C886.363 13.0993 886.193 10.5356 885.854 7.87112C885.423 4.4879 884.713 0.908785 883.879 -2.50807C885.944 0.338956 888.213 3.19658 890.513 5.7147C892.325 7.69788 894.17 9.48591 895.962 10.8952C897.719 12.2763 899.48 13.3375 901.152 13.8301C902.745 14.5367 904.775 14.8675 907.008 14.9515C909.286 15.0372 911.85 14.868 914.515 14.5285C917.898 14.0975 921.477 13.3874 924.894 12.5535C922.047 14.6186 919.189 16.8876 916.671 19.1878C914.688 20.9993 912.9 22.8442 911.491 24.6368C910.109 26.3934 909.048 28.1545 908.556 29.8266C907.849 31.4201 907.518 33.4495 907.434 35.6824C907.349 37.961 907.518 40.5247 907.857 43.1892C908.288 46.5724 908.998 50.1515 909.832 53.5684C907.767 50.7214 905.498 47.8637 903.198 45.3456C901.386 43.3624 899.542 41.5744 897.749 40.1651C895.992 38.784 894.231 37.7228 892.559 37.2302C890.966 36.5236 888.936 36.1928 886.703 36.1089C884.425 36.0232 881.861 36.1923 879.197 36.5318C875.813 36.9629 872.234 37.673 868.817 38.5069Z",
    fill: "#0B121F",
    stroke: "#9FEF00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87867 332.097C-69.0228 48.8292 99.0807 -242.334 382.349 -318.236C665.617 -394.137 956.78 -226.034 1032.68 57.234C1108.58 340.502 940.48 631.666 657.212 707.567C373.944 783.469 82.7801 615.365 6.87867 332.097Z",
    stroke: "#202837",
    strokeWidth: 2.07053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.397 -331.376C450.477 -331.798 453.567 -332.195 456.666 -332.566C687.709 -360.227 901.833 -235.117 997.84 -36.7963",
    stroke: "#9FEF00",
    strokeWidth: 2.07053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.605 723.427C253.748 702.926 63.7286 550.464 5.92351 328.465C4.3478 322.414 2.88246 316.359 1.52748 310.303",
    stroke: "#9FEF00",
    strokeWidth: 2.07053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.69 57.8409L966.105 27.8197L996.126 -39.7653L1063.71 -9.74412L1033.69 57.8409Z",
    fill: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.106 27.8203L996.127 -39.7655L1063.71 -9.74349L966.106 27.8203Z",
    fill: "#8CCB0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.50761 250.57L-33.8838 318.258L37.4238 306.391L-8.50761 250.57Z",
    fill: "#9FEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.282 373.939C-248.293 4.42378 -29.006 -375.393 340.51 -474.404C710.025 -573.415 1089.84 -354.128 1188.85 15.3872C1287.86 384.903 1068.58 764.719 699.062 863.731C329.546 962.742 -50.2702 743.455 -149.282 373.939Z",
    stroke: "#202837",
    strokeWidth: 2.12014,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140.217 405.359C-154.602 360.141 -164.531 312.754 -169.446 263.654C-194.985 8.50752 -78.6438 -228.135 115.485 -367.921",
    stroke: "#9FEF00",
    strokeWidth: 2.12016,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.173 283.875L261.001 258.493L286.383 248.321L296.555 273.703L271.173 283.875Z",
    fill: "#8CCB0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.001 258.493L286.383 248.321L296.555 273.703L261.001 258.493Z",
    fill: "#9FEF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOulinesBg);
export default __webpack_public_path__ + "static/media/oulines-bg.174af115d34b1c1d87dc5b27efb0a80f.svg";
export { ForwardRef as ReactComponent };